import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const BusinessContext = createContext(null);

export function BusinessProvider({ children }) {
  const [business, setBusiness] = useState({
    name: "Maison Noir",
    tagline: "",
    logo_url: "",
    email: "",
    phone: "",
    address: "",
    currency: "MYR",
    qr_payment_image: "",
    about: "",
  });
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/business-info");
      setBusiness(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <BusinessContext.Provider value={{ business, loading, refresh, setBusiness }}>
      {children}
    </BusinessContext.Provider>
  );
}

export const useBusiness = () => {
  const ctx = useContext(BusinessContext);
  if (!ctx) throw new Error("useBusiness must be used within BusinessProvider");
  return ctx;
};
